import React from 'react';
import './HeroTech.css';

const HeroTech = () => {
    return (
        <section className="ht-hero">
            <div className="ht-hero__container container">
                <div className="ht-hero__row row align-items-center">
                    {/* Left: Text and CTA */}
<div className="ht-hero__content-col col-12 col-lg-6">
    <div className="ht-hero__content">
        <p className="ht-hero__tagline">Trusted Technical Excellence in Dubai</p>
        <h1 className="ht-hero__headline">Premier Civil, MEP & AC Services</h1>
        <p className="ht-hero__description">
            Civil & MEP Services | AMC Contracts | Painting & Fitouts | AC Installation & Maintenance
            <br /><strong>Delivering Dubai projects with skilled teams and proven capabilities.</strong>
        </p>
        <a href="/contact" className="ht-hero__cta theme-btn">
            Get Free Quote
        </a>
    </div>
</div>

                    {/* Right: Image collage */}
                    <div className="ht-hero__collage-col col-12 col-lg-6">
                        <div className="ht-hero__collage">
                            <div className="ht-hero__collage-img ht-hero__collage-img--left">
                                <img src="/img/projects/hero2.jpg" alt="AC maintenance" />
                            </div>
                            <div className="ht-hero__collage-img ht-hero__collage-img--center">
                                <img src="/img/projects/hero1.jpg" alt="Technical work" />
                            </div>
                            <div className="ht-hero__collage-img ht-hero__collage-img--right">
                                <img src="/img/projects/hero3.jpg" alt="Electrical services" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroTech;
